"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSDeleteShiftsSection = void 0;
const ac_1 = require("@app/ac");
const confirm_1 = __importDefault(require("@app/component/modals/confirm"));
const ui_1 = require("@app/component/ui");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const use_modal_1 = require("@app/util/modal/use-modal");
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
// OFF_TYPE_DELETE_MULTI
// DELETE_SHIFTS_WARNING
const CSDeleteShiftsSection = () => {
    const calendar = (0, store_1.useRootSelector)((state) => state.calendar);
    const shifts = (0, store_1.useRootSelector)((state) => state.shifts);
    const calendarFilters = (0, store_1.useRootSelector)((state) => state.calendarFilters);
    const calPeriod = calendar && util_1.calendarUtil.getReloadPeriod(calendar);
    const filteredShiftsInPeriod = shifts?.length && calPeriod
        ? util_1.calendarUtil
            .getFilteredEvents(shifts, calendarFilters)
            .filter((s) => (0, moment_1.default)(s.period.start).isSameOrAfter(calPeriod.start) &&
            (0, moment_1.default)(s.period.start).isSameOrBefore(calPeriod.end))
        : [];
    const { addModal } = (0, use_modal_1.useModal)();
    const dispatch = (0, store_1.useRootDispatch)();
    const deleteShifts = react_1.default.useCallback(() => addModal(confirm_1.default, {
        title: (0, util_1.t)('MULTI_ACTION_DEL_CONFIRM_TITLE'),
        type: ui_1.Alert.TYPES.ERROR,
        confirmLabel: (0, util_1.t)('DELETE'),
        onConfirm: async () => {
            await dispatch((0, ac_1.deleteLiveShift)(null, filteredShiftsInPeriod.map((s) => s.id))); // del shifts
        },
        cancelLabel: (0, util_1.t)('CANCEL'),
        onCancel: () => { },
        subtitle: (0, util_1.t)('MULTI_ACTION_DEL_CONFIRM_DELETE_SUBTITLE_X', {
            x: filteredShiftsInPeriod.length,
        }),
        recordsList: filteredShiftsInPeriod,
        buttonColor: 'red',
    }), [shifts, calendarFilters, calPeriod]);
    return (react_1.default.createElement("div", { style: {
            width: '100%',
            display: 'flex',
            alignItems: 'start',
            flexDirection: 'column',
            gap: '0.5rem',
            padding: '0.75rem',
        } },
        react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_LARGE, weight: ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)('OFF_TYPE_DELETE_MULTI')),
        react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_12, type: ui_1.Spacing.TYPES.VERTICAL }),
        react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_MEDIUM }, (0, util_1.t)('DELETE_SHIFTS_WARNING')),
        react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_12, type: ui_1.Spacing.TYPES.VERTICAL }),
        react_1.default.createElement(ui_1.Button, { ico: 'delete', color: 'RED', style: 'UNDERLINED', onClick: deleteShifts }, (0, util_1.t)('DELETE_SHIFTS_IN_PERIOD'))));
};
exports.CSDeleteShiftsSection = CSDeleteShiftsSection;
